// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"281":"976aae30","580":"976aae30"}[chunkId] + ".chunk.css");